(() => {
  const label = document.currentScript?.dataset.emptyReviews;
  const root = document.getElementById('MainContent');
  if (!label || !root) return;
  const translate = () => {
    root.querySelectorAll('.itg-card .start-text').forEach((element) => {
      if (element.textContent.trim() === 'No reviews') element.textContent = label;
    });
  };
  translate();
  new MutationObserver(translate).observe(root, { childList: true, subtree: true });
})();
